import { axiosInstance } from 'services/axiosInstance'
import { TSuccessResponse } from 'types/comonApi'

import { IAdvise } from '../types'

export const insertAdvise = (payload: IAdvise): Promise<TSuccessResponse<any>> =>
  axiosInstance.post('/home-loan-be/api/v1/ldp/advise-customer', payload)
